import { loadStripe } from "@stripe/stripe-js"
import { clientEnv } from "config"

export const stripePromise = loadStripe(clientEnv.STRIPE_KEY)

type Prices = {
  month: {
    first: number
    rest: number
  }
  year: {
    first: number
    rest: number
  }
}
export const computeMapTestingSubscriptionTotal = (
  prices: Prices,
  billingType: keyof Prices,
  numberOfStudents: number,
  upgradeDiscount?: number
) => {
  let total = (prices[billingType].first + (numberOfStudents - 1) * prices[billingType].rest) / 100
  total = upgradeDiscount ? total - upgradeDiscount : total

  return total
}
